module.exports = __webpack_public_path__ + "static/media/light_blue_mark_icon.0012c6cf.svg";